import { noTagPage, getById } from '@/api/business/bulkOrder'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(noTagPage, getById)
